module.exports = new __parcel__URL__("marc-fourrier.517bdfc3.jpeg").toString();